import dayjs from 'dayjs'

/**
 * Formats a notification send date in the standard mobile format.
 * Requires dayjs utc + timezone plugins (extended globally in config/dayjs-setup.ts).
 *
 * @param dateStr - UTC date string
 * @param tz - IANA timezone (e.g., 'America/New_York')
 * @returns Formatted string like "May 19, 2026 at 3:30 PM EDT"
 */
export function formatNotificationDate(dateStr: string | null | undefined, tz: string): string {
    if (!dateStr) return '--'
    return dayjs.utc(dateStr).tz(tz).format('MMM D, YYYY [at] h:mm A z')
}
